import ReactPlayer from 'react-player';
import { useContextRef } from 'react-context-refs';
import { useSelector, useDispatch } from 'react-redux';
import {
	setIsReady,
	setProgressCompleted,
	setProgressLoaded,
	setDuration,
	onEndPlayer
} from 'Actions';
import styles from 'partials/player.module.scss';

export const Player = () => {
	const player = useContextRef();
	const track = useSelector((state) => state.player);
	const dispatch = useDispatch();
	const isPlaying = track.isPlaying;

	const handleReady = () => {
		dispatch(setIsReady(true));
	};

	const handleDuration = (duration) => {
		dispatch(setDuration(duration));
	};

	const handleProgress = (progress) => {
		if (progress.played < 1) {
			dispatch(setProgressLoaded(progress.loaded * 100));
			dispatch(setProgressCompleted(progress.played * 100));
		}
	};

	const handleEndPlayer = () => {
		dispatch(setProgressCompleted(0));
		dispatch(onEndPlayer());
	};

	return (
		<ReactPlayer
			ref={player}
			url={track?.activeTrack?.file_url?.origin}
			className={styles.player}
			playing={isPlaying}
			progressInterval={830}
			onReady={handleReady}
			onDuration={handleDuration}
			onProgress={handleProgress}
			onEnded={handleEndPlayer}
			config={{
				file: {
					forceAudio: true
				}
			}}
		/>
	);
};
